"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Fields, System } from "Constants/objects";
import { Model } from "Model";
import FormEditStore from "Stores/Forms/FormEditStore";
import { UserScriptField } from "UserActionHandler/UserScriptField";
import { UserScriptTable } from "UserActionHandler/UserScriptTable";
import { user } from "Models/UserModel";
import { Collection } from "Collection";
import { showSnackBar } from "Actions/D5SnackbarsActions";
import UserScriptFormFilterModel from "UserActionHandler/UserScriptFormFilterModel";
import { Messages } from "Messages"; // import {UserScriptFormEvents, UserScriptTableEvents} from "UserActionHandler/UserScriptEvents";

/**
 * @module UserScriptModel
 * @requires UserScriptField
 * @requires UserScriptTable
 * @requires UserScriptFormFilterModel
 * @exports UserScriptModel
 */

/**
 *  Class representing API for user defined scripts. Can be applied to a Form and Table.
 *  If it applies to the Form than the class includes its fields and nested tables.
 *  If it applies to the Table than the class accesses to the columns. Uses for the TableForm(not nested)
 */

export var UserScriptModel =
/*#__PURE__*/
function () {
  /**
   * Uses for Nested tables
   * @type {Object}
   * @private
   */

  /**
   * @type {FormEditStore}
   * @private
   */

  /**
   * @type {String}
   * @private
   */
  //TODO Переделать на UserScriptTableEvents и UserScriptFormEvents

  /**
   * @param {array} settings View settings for Form fields/Table columns
   * @param {object} data Form data or row data in the table.
   * @param {object} props Additional properties used in script. For instance, nested tables.
   * @param {String} initiator Who is initializing the script. ('formEdit|table')
   * @hideconstructor
   */
  function UserScriptModel(settings, data) {
    var _this = this;

    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var initiator = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, UserScriptModel);

    _defineProperty(this, "_data", {});

    _defineProperty(this, "_fieldsViewSettings", {});

    _defineProperty(this, "_props", {});

    _defineProperty(this, "_tables", {});

    _defineProperty(this, "_owner", void 0);

    _defineProperty(this, "__initiator", void 0);

    _defineProperty(this, "formEvents", {
      // onDisposing: null,
      onInitialized: null,
      onInitNewRow: null,
      onDeleteRow: null,
      onSaveRow: null,
      onSelectionChanged: null,
      onRowAfterSave: null,
      onRowBeforeSave: null,
      onBeforeGetData: null,
      onEditorPreparing: null
    });

    this._data = _objectSpread({}, data);
    this._props = props;
    this._tables = {};
    this._owner = props.owner;
    this._initiator = initiator;
    if (props.filter) this._filter = new UserScriptFormFilterModel(props.filter);

    if (this._owner && this._owner instanceof FormEditStore && initiator !== System.USER_SCRIPTS_INITIATOR.FORM_EDIT) {
      this._ownerModel = new UserScriptModel(this._owner.fieldData, this._owner.getFormData(), System.USER_SCRIPTS_INITIATOR.FORM_EDIT);
    }

    var customProps = ['onValueChanged', "onMasterSelectFilter", "_filter"];

    _.each(settings, function (item) {
      customProps.forEach(function (prop) {
        if (!item.hasOwnProperty(prop)) item[prop] = null;
      });
      _this._fieldsViewSettings[item[Fields.Name]] = _objectSpread({}, item);
    });
  }

  _createClass(UserScriptModel, [{
    key: "initiatorIsTable",

    /**
     * Returns true if the initiator of the script is Table
     * @return {boolean}
     */
    value: function initiatorIsTable() {
      return this._initiator === System.USER_SCRIPTS_INITIATOR.TABLE;
    }
    /**
     * Returns true if the initiator of the script is FormEdit
     * @return {boolean}
     */

  }, {
    key: "initiatorIsFormEdit",
    value: function initiatorIsFormEdit() {
      return this._initiator === System.USER_SCRIPTS_INITIATOR.FORM_EDIT;
    }
    /**
     * Uses in user defined scripts. Loading data from the server. Returns Model of the object.
     * @param {array} columns
     * @param {object} filter
     * @param {string} objectName
     * @return {Promise<object>}
     * @see {@link https://wiki.macc.com.ua/pages/viewpage.action?pageId=6029336}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise}
     * @example <caption>Example usage of loadObjectData.</caption>
     * model.loadObjectData({
     *           filter: {ID: 10},
     *           columns: ['ID', 'Name'],
     *           objectName: 'ObjectName'
     *       })
     *       .then(data => ...)
     *       .catch(error => ...);
     */

  }, {
    key: "loadObjectData",
    value: function loadObjectData(_ref) {
      var _ref$columns = _ref.columns,
          columns = _ref$columns === void 0 ? [] : _ref$columns,
          _ref$filter = _ref.filter,
          filter = _ref$filter === void 0 ? {} : _ref$filter,
          _ref$objectName = _ref.objectName,
          objectName = _ref$objectName === void 0 ? '' : _ref$objectName;
      return new Promise(function (resolve) {
        var DataModel = Model.extend({
          object: objectName
        });
        new DataModel().fetch({
          data: {
            Columns: columns,
            Page: -1,
            Filters: filter
          },
          success: function success(model) {
            resolve(model.attributes);
          },
          error: function error(model, response) {
            showSnackBar({
              type: System.SNACKBAR_TYPES.Error,
              message: response.ResponseText
            });
            resolve([]);
          }
        });
      });
    }
    /**
     * Uses in user defined scripts. Loading data from the server. Returns the object Collection of the Models.
     * @param {array} columns
     * @param {object} filter
     * @param {string} objectName
     * @return {Promise<object>}
     * @see {@link https://wiki.macc.com.ua/pages/viewpage.action?pageId=6029336}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise}
     * @example <caption>Example usage of loadObjectCollection.</caption>
     * model.loadObjectCollection({
     *           filter: {ID: 10},
     *           columns: ['ID', 'Name'],
     *           objectName: 'ObjectName'
     *       })
     *       .then(data => ...)
     *       .catch(error => ...);
     */

  }, {
    key: "loadObjectCollection",
    value: function loadObjectCollection(_ref2) {
      var _ref2$columns = _ref2.columns,
          columns = _ref2$columns === void 0 ? [] : _ref2$columns,
          _ref2$filter = _ref2.filter,
          filter = _ref2$filter === void 0 ? {} : _ref2$filter,
          _ref2$objectName = _ref2.objectName,
          objectName = _ref2$objectName === void 0 ? '' : _ref2$objectName;
      return new Promise(function (resolve) {
        var DataModel = Model.extend({
          object: objectName
        });
        var collection = new (Collection.extend({
          model: DataModel,
          object: objectName
        }))();
        collection.fetch({
          data: {
            Columns: columns,
            Page: -1,
            Filters: filter
          },
          success: function success(collect) {
            resolve(collect.toJSON());
          },
          error: function error(model, response) {
            showSnackBar({
              type: System.SNACKBAR_TYPES.Error,
              message: response.ResponseText
            });
            resolve([]);
          }
        });
      });
    }
  }, {
    key: "changeObjectCollection",
    value: function changeObjectCollection(_ref3) {
      var _ref3$objectName = _ref3.objectName,
          objectName = _ref3$objectName === void 0 ? '' : _ref3$objectName,
          _ref3$request = _ref3.request,
          request = _ref3$request === void 0 ? [] : _ref3$request,
          operation = _ref3.operation;
      return new Promise(function (resolve) {
        var operationName;
        var ObjectModel = Model.extend({
          initialize: function initialize() {
            this.object = objectName;
          }
        });
        var models = request.map(function (data) {
          return new ObjectModel(data);
        });
        var coll = new Collection(models);
        coll.model = ObjectModel;
        coll.object = objectName;

        switch (operation) {
          case System.API_OPERATION.CREATE:
            operationName = 'create';
            break;

          case System.API_OPERATION.UPDATE:
            operationName = 'update';
            break;

          case System.API_OPERATION.DELETE:
            operationName = 'delete';
            break;
        }

        coll.sync(operationName, coll, {
          success: function success() {
            if (operation === System.API_OPERATION.DELETE) {
              showSnackBar({
                type: System.SNACKBAR_TYPES.Success,
                message: Messages.Message.Deleted
              });
            } else {
              showSnackBar({
                type: System.SNACKBAR_TYPES.Success,
                message: Messages.Success.Saved
              });
            }
          },
          error: function error(response) {
            showSnackBar({
              type: System.SNACKBAR_TYPES.Error,
              message: response.ResponseText
            });
          }
        });
      });
    }
    /**
     * Uses in user defined scripts. Loading/Creating/Updating/Removing data from the server. Returns the object Collection of the Models when using List operation.
     * @param {string} objectName
     * @param {string} operationName
     * @param {object} requestData if using List operation, if using Ins/Mod/Del operation requestData is type array
     * @return {Promise<object>}
     * @see {@link https://wiki.macc.com.ua/pages/viewpage.action?pageId=6029330}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise}
     * @example <caption>Example usage of execServerOperation for List operation.</caption>
     * model.execServerOperation('App_Sales', 'List', {
     *           filter: {ID: 10},
     *           columns: ['ID', 'Name']
     *       })
     *       .then(data => ...)
     *       .catch(error => ...);
     * @example <caption>Example usage of execServerOperation for Ins operation.</caption>
     * model.execServerOperation('App_Users', 'Ins', [{Name: 'Bob', Surname: 'Nickson'}, {Name: 'Bill', Surname: 'Smith'}]);
     * @example <caption>Example usage of execServerOperation for Mod operation.</caption>
     * model.execServerOperation('App_Users', 'Mod', [{ID: 1, Surname: 'Nickson'}, {ID: 2, Surname: 'Smith"'])
     * @example <caption>Example usage of execServerOperation for Del operation.</caption>
     * model.execServerOperation('App_Users', 'Del', [{ID: 1}, {ID: 2}])
     */

  }, {
    key: "execServerOperation",
    value: function execServerOperation(object, operationName, requestData) {
      switch (operationName) {
        case System.API_OPERATION.READ:
          return this.loadObjectCollection({
            objectName: object,
            filter: requestData.filter,
            columns: requestData.columns
          });

        case System.API_OPERATION.CREATE:
        case System.API_OPERATION.UPDATE:
        case System.API_OPERATION.DELETE:
          return this.changeObjectCollection({
            objectName: object,
            request: requestData,
            operation: operationName
          });
      }
    }
    /**
     * Uses in user defined scripts. Returns a form operation.
     * @return {*} String
     * @example <caption>Example usage of formOperation.</caption>
     * if (model.formOperation() === 'Ins') {...}
     */

  }, {
    key: "formOperation",
    value: function formOperation() {
      return this._props.formOperation;
    }
    /**
     * Uses in user defined scripts. Defines if the field is a table.
     * @param {string} formName TableForm name.
     * @example <caption>Example usage of isTable.</caption>
     * if (model.isTable('Sales')) {...}
     */

  }, {
    key: "isTable",
    value: function isTable(formName) {
      return this._owner && this._owner.formHasTable(formName);
    }
    /**
     * Uses in user defined scripts. Returns a field depending on field types.
     * If the function is invoked by the Form[Edit|Filter], then the returned object will be an instance of UserScriptTable|UserScriptField.
     * If the function is invoked by the Table, then the returned object will be an instance of UserScriptField.
     * @param {string} fieldName
     * @return {(UserScriptTable|UserScriptField)}
     * @see module:UserScriptTable.UserScriptTable
     * @see module:UserScriptField.UserScriptField
     * @example <caption>Example usage of getFieldByName if the sender is an edit form.</caption>
     * let fld = model.getFieldByName('Sales');
     * if (model.isTable('Sales')) {
     *      //fld is an instance of UserScriptTable
     * } else {
     *      //fld is an instance of UserScriptField
     * }
     * @example <caption>Example usage of getFieldByName if the sender is a table.</caption>
     * let TableNameFld = model.getFieldByName(Name);
     *
     * if (model.owner) {
     *     let FormNameFld = model.owner.getFieldByName(Name);
     *     FormNameFld.value(TableNameFld.value());
     * }
     */

  }, {
    key: "getFieldByName",
    value: function getFieldByName(fieldName) {
      if (this.isTable(fieldName)) {
        if (!this._tables.hasOwnProperty(fieldName)) {
          this._tables[fieldName] = this._owner.getTableByName(fieldName);
        }

        return new UserScriptTable(this._tables[fieldName]);
      }

      return new UserScriptField(this, fieldName);
    }
    /**@description Returns an instance of UserScriptFormFilterField by name.
     * @param {String} name
     * @return {UserScriptFormFilterField}
     */

  }, {
    key: "getFilterByName",
    value: function getFilterByName(name) {
      if (this._filter) {
        return this._filter.getFilterByName(name);
      }
    }
    /**
     * Returns an array of fields (UserScriptTable|UserScriptField)
     * @see module:UserScriptTable.UserScriptTable
     * @see module:UserScriptField.UserScriptField
     * @return {Array}
     * @example
     * Button1OnClick: function (model) {
     *      let dump = {};
     *      for(let field of model.getFieldsList()) {
     *          dump[field.fieldName] = field.value();
     *      }
     *
     *      console.log(dump);
     *
     *      return model;
     * }
     */

  }, {
    key: "getFieldsList",
    value: function getFieldsList() {
      var list = [];

      for (var fieldName in this._fieldsViewSettings) {
        if (this._fieldsViewSettings.hasOwnProperty(fieldName) && fieldName.indexOf(System.SYSTEM_PREFIX) !== 0) {
          list.push(this.getFieldByName(fieldName));
        }
      }

      return list;
    }
    /**
     * Returns an array of filters `UserScriptFormFilterField`
     * @see module:UserScriptFormFilterModel.UserScriptFormFilterField
     * @see module:UserScriptFormFilterModel.UserScriptFormFilterModel
     * @return {Array}
     * @example
     * Button1OnClick: function (model) {
     *      let dump = {};
     *      for(let field of model.getFiltersList()) {
     *          dump[field.fieldName] = field.value();
     *      }
     *
     *      console.log(dump);
     *
     *      return model;
     * }
     */

  }, {
    key: "getFiltersList",
    value: function getFiltersList() {
      var list = [];

      if (this._filter) {
        for (var fieldName in this._filter.viewSource) {
          if (this._filter.viewSource.hasOwnProperty(fieldName) && fieldName.indexOf(System.SYSTEM_PREFIX) !== 0) {
            list.push(this._filter.getFilterByName(fieldName));
          }
        }
      }

      return list;
    }
  }, {
    key: "getSourceData",
    value: function getSourceData() {
      return _objectSpread({}, this._data);
    }
  }, {
    key: "getSourceView",
    value: function getSourceView() {
      var out = [];

      for (var view in this._fieldsViewSettings) {
        if (this._fieldsViewSettings.hasOwnProperty(view)) out.push(this._fieldsViewSettings[view]);
      }

      return out;
    }
  }, {
    key: "getProps",
    value: function getProps() {
      if (this._filter instanceof UserScriptFormFilterModel) this._props.filter = this._filter.getFilter();
      return this._props;
    }
  }, {
    key: "getTables",
    value: function getTables() {
      for (var tableName in this._tables) {
        if (this._tables.hasOwnProperty(tableName)) if (this._tables[tableName].filter.filterModel instanceof UserScriptFormFilterModel) this._tables[tableName].filter = this._tables[tableName].filter.filterModel.getFilter();
      }

      return this._tables;
    }
    /** Uses in user defined scripts. Returns keys of selected/processed rows.
     * Read only.
     * @return {Object}
     * @readonly
     * @example
     * console.log(model.rowKeys);
     */

  }, {
    key: "setCascadeSelectUpdating",

    /**Applies filter to a lookup field and returns current model.
     * Must be called on the `onMasterSelectFilter` and `formInit` events.
     * @param {string} detailFieldName - ObjectFieldID_Name выпадающего списка, который нужно обновлять
     * @param {array|null} filter
     * @return {UserScriptModel}
     * @example
     * let master = fields.getFieldByName(ProductKindID);
     * fields.setCascadeSelectUpdating(ProductID, ['ProductKindID', '=', master.value()]);
     */
    value: function setCascadeSelectUpdating(detailFieldName, filter) {
      var detailFld = this.getFieldByName(detailFieldName);
      detailFld.filter(filter);
      return this;
    }
    /**Shows the notification due to selected type and message.
     * @param {String} type Available values : `success`|`error`|`warning`|`info`
     * @param {String} message Any `String` value.  For setting a linebreak should use`<br/>`
     * @example
     * model.showNotification("success", "Some text <br/> it's a new line")
     */

  }, {
    key: "showNotification",
    value: function showNotification(type, message) {
      showSnackBar({
        type: type,
        message: message
      });
    }
    /**
     * Uses in user defined scripts.
     * Returns or sets the form edit mode.
     * @return {boolean}
     * @param {boolean} value
     * @example <caption>Example usage of setting the mode for the edit form.</caption>
     * Button1OnClick: (model) => {
     *      model.readOnly(true);
     *      return model;
     * }
     * @example <caption>Example usage for reading the mode of the edit form.</caption>
     * someFieldChanged: function (model) {
     *     const currentMode = model.readOnly();
     *
     *     if (!currentMode) {
     *         ....
     *     }
     *
     *      return model;
     * }
     */

  }, {
    key: "readOnly",
    value: function readOnly(value) {
      return value != null ? this._props.isReadOnlyForm = value : this._props.isReadOnlyForm;
    }
  }, {
    key: "rowKeys",
    get: function get() {
      return this._props.rowKeys;
    }
    /**Uses in user defined scripts. Returns a response object which is received in the `login` operation.
     * Read only.
     * @return {Object}
     * @readonly
     * @example
     * console.log(model.currentUser.UserID);
     * console.log(model.currentUser.Name);
     * console.log(model.currentUser.PersonID);
     */

  }, {
    key: "currentUser",
    get: function get() {
      return user.currentUser();
    }
    /**
     * Uses in user defined scripts. If the script is invoked by the Table and it's NestedTable, it provides a reference
     * to a parent form.
     * @return {UserScriptModel}
     * @example
     * let TableNameFld = model.getFieldByName(Name);
     *
     * if (model.owner) {
     *     let FormNameFld = model.owner.getFieldByName(Name);
     *     FormNameFld.value(TableNameFld.value());
     * }
     */

  }, {
    key: "owner",
    get: function get() {
      return this._ownerModel;
    }
    /**
     * Sets and returns the page size of a table. Uses on the `formInit` event.
     * @return {number}
     * @param {number} pageSize
     */

  }, {
    key: "pageSize",
    get: function get() {
      return this._props.pageSize;
    },
    set: function set(pageSize) {
      this._props.pageSize = pageSize;
    }
  }]);

  return UserScriptModel;
}();